// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"99890586-567":"fe7a30d1318587925776","99890586-452":"4a5d1d386bb9cb89ba27","99890586-812":"11e7a897c51eef820ca5","99890586-83":"728ac1493fabf5270bb1"}[chunkId] + ".js";
};